import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router-dom';
import { api } from '../../lib/api.js';
import {
  APP_TITLE,
  type TabTitleProject,
  pageTitleFor,
  projectTabTitle,
  withAppTitle,
} from '../../lib/document-title.js';

/**
 * Issue #138 — setzt den Browsertab-Titel passend zur aktuellen Route. Eine Stelle für die ganze
 * App, damit beim Seitenwechsel nie ein alter Projekttitel stehen bleibt.
 *
 * Auf der Projektseite liest die Komponente dieselbe Query wie `ProjectDetailV2Page`
 * (`['v2-project', id]`) — react-query legt beide Abrufe zusammen, es gibt keinen zweiten Request.
 */
export function DocumentTitle() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const projectId = matchPath('/projects/:projectId', pathname)?.params.projectId;

  const projectQuery = useQuery({
    queryKey: ['v2-project', projectId],
    queryFn: () => api.getProject(projectId as string) as Promise<TabTitleProject>,
    enabled: !!projectId,
  });

  let title: string;
  if (projectId) {
    title = projectQuery.data ? projectTabTitle(projectQuery.data) : APP_TITLE;
  } else {
    const page = pageTitleFor(pathname);
    title = withAppTitle(page ? t(page.key, page.fallback) : null);
  }

  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
